export default __webpack_public_path__ + "static/media/unlock2.7535c4ff.png";